export { SCENE_TIME_VALUES, isSceneTime, type SceneTime } from "@lingjingai/screenplay/schema";

import { SCENE_TIME_VALUES, type SceneTime } from "@lingjingai/screenplay/schema";

const TIME_ALIASES: Readonly<Record<string, SceneTime>> = {
  day: "day",
  "日": "day",
  "白天": "day",
  "日间": "day",
  "昼": "day",
  "昼间": "day",
  night: "night",
  "夜": "night",
  "夜晚": "night",
  "夜间": "night",
  "晚": "night",
  dawn: "dawn",
  "晨": "dawn",
  "清晨": "dawn",
  "早晨": "dawn",
  "黎明": "dawn",
  "拂晓": "dawn",
  dusk: "dusk",
  "昏": "dusk",
  "黄昏": "dusk",
  "傍晚": "dusk",
  "日落": "dusk",
};

export function normalizeSceneTime(value: unknown): SceneTime | undefined {
  if (typeof value !== "string") return undefined;
  const normalized = value.normalize("NFC").replace(/\s+/g, "").trim().toLocaleLowerCase();
  return TIME_ALIASES[normalized];
}


